import React from 'react';
import PropTypes from 'prop-types'

export default class TemplateComponent extends React.Component {
  static contextTypes = {
    pid: PropTypes.string,
    sysid: PropTypes.string,
    mid: PropTypes.string,
    id: PropTypes.string,
    onEvent: PropTypes.func,
    viewModel: PropTypes.object,
    appState: PropTypes.object,
    eventHanding: PropTypes.bool,
  }

}
